import en from "../locales/en.json";
import de from "../locales/de.json";
import fr from "../locales/fr.json";

export const messages = {
	en,
	de,
	fr,
};
